<p-select
  class="ddi-select"
  [formControl]="country"
  [options]="ddiList"
  optionLabel="name"
  dataKey="acronym"
  ariaLabel="País e DDI"
  [filter]="true"
  filterBy="name,code"
  filterLocale="pt-BR"
  filterPlaceholder="Buscar país ou DDI"
  ariaFilterLabel="Buscar país ou DDI"
  emptyFilterMessage="Nenhum país encontrado"
  [resetFilterOnHide]="true"
  appendTo="body"
  [panelStyle]="panelStyle"
  scrollHeight="240px"
  (onChange)="selectOption($event.value)"
  (onBlur)="onTouched()">
  <ng-template #selectedItem let-selected>
    <span class="ddi-select__selected" [title]="selected.name + ' (' + selected.code + ')'">
      <img [src]="selected.flag" alt="" class="ddi-select__flag" />
      <span>{{ selected.code }}</span>
    </span>
  </ng-template>
  <ng-template #item let-item>
    <span class="ddi-select__option">
      <img [src]="item.flag" alt="" class="ddi-select__flag" />
      <span class="ddi-select__name">{{ item.name }}</span>
      <span class="ddi-select__code">{{ item.code }}</span>
    </span>
  </ng-template>
</p-select>
